<template>
    <div>
        <app-text
            label="Titel"
            :data-source="
                'tecpage.user.modules.' + moduleId + '.data.documents.' + listitemId + '.data.name'
            "
            :data-default="{ type: 'raw', value: 'Ihr Titel' }"
            required
            :maxlength="255"
        ></app-text>

        <app-text
            label="Text"
            :data-source="
                'tecpage.user.modules.' + moduleId + '.data.documents.' + listitemId + '.data.text'
            "
            :data-default="{ type: 'raw', value: 'Ihre Beschreibung' }"
            :maxlength="255"
        ></app-text>

        <app-filepicker
            label="Datei"
            :data-source="
                'tecpage.user.modules.' + moduleId + '.data.documents.' + listitemId + '.data.file'
            "
            accept=".pdf,.doc,.docx,.xls,.xlsx,.zip,.exe"
            required
        ></app-filepicker>
    </div>
</template>

<script>
import Text from '@/components/fields/simple/Text.vue';
import Filepicker from '@/components/fields/complex/Filepicker.vue';

export default {
    data() {
        return {};
    },
    methods: {},
    computed: {},
    mounted() {
        this.$emit('controlhead', {
            title: this.$helpers.uiText('R008'),
            help: this.$helpers.uiText('R009'),
            removeText: this.$helpers.uiText('R010')
        });
    },
    props: {
        moduleId: String,
        listitemId: String
    },
    components: {
        'app-text': Text,
        'app-filepicker': Filepicker
    }
};
</script>
